import { render, staticRenderFns } from "./TechnicalTreasureMsgAddLayer.vue?vue&type=template&id=fda6728c&scoped=true&"
import script from "./TechnicalTreasureMsgAddLayer.vue?vue&type=script&lang=js&"
export * from "./TechnicalTreasureMsgAddLayer.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalTreasureMsgAddLayer.vue?vue&type=style&index=0&id=fda6728c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda6728c",
  null
  
)

export default component.exports